

if ($('#page-story.sub-episode').length) episode();


function episode() {

    // 開始番号調整
    var NUMBER_DIFF = 1;

    var _data = {
        is_complete: false, // 読み込み終わったか
        episode_list: [],   // 各話データ
        now_list: null,     // 現在表示している話数：サイドメニュー用
        now_episode: null,  // 現在表示している話数：エピソード用
        now_gallery: 0  // 表示するギャラリー
    };
    var _vm_submenu = null;
    var _vm_episode = null;

    $.ajax('episode_data.json', { dataType: 'json', cache:false })
    .done(function (data) {
        _data.episode_list = data.episode_list;
        init_episode();
    });

    /**
     * エピソードのVueを設定
     */
    function init_episode() {

        // urlから表示する話数を出す
        // 指定がなければ最新話を表示
        var show_num = get_num_from_url();
        _data.now_list = show_num;
        _data.now_episode = show_num;

        // サイドメニュー
        _vm_submenu = new Vue({
            el: '#app-list',
            data: _data,
            methods: {
                change_now: change_now
            }
        })

        _vm_episode = new Vue({
            el: '#app-episode',
            data: _data,
            computed: {
                episode: function () {
                    return this.episode_list[this.now_episode];
                },
                convert_number: function () {
                    var str = this.episode.number;
                    str = str.replace(/(\d+)/, '<span>$1</span>');
                    return str;
                }
            },
            methods: {
                change_gallery: change_gallery
            }
        });

        // 最初の話数を表示
        change_now(show_num, null);
    }

    /**
     * URLから話数を生成
     */
    function get_num_from_url() {
        if (!$('body.sub-episode').length) {
            // 各話ページではない
            return null;
        }else if( location.hash ){
            return parseInt(location.hash.substr(1)) - NUMBER_DIFF;
        }else{
            return _data.episode_list.length -1
        }
    }

    /**
    * 表示話数変更
    */
    function change_now(num, event) {

        // 各話ページでない場合は普通のリンクとして動かす
        if( !$('body.sub-episode').length ){
            if( event ) window.location = event.target.href;
            return;
        }

        // リストの番号だけ先に変更
        _data.now_list = num;
        // ステータスを読み込み中にする
        _data.is_complete = false;

        // 画像をプリロード
        preload_gallery(num)
        .done( function( total, count ){

            // 読み込み終わったので表示
            _data.now_episode = num;
            _data.is_complete = true;

            // タイトルとURL変更
            var base_title = document.title.substr( document.title.indexOf(' |') );
            document.title = _vm_episode.episode.number + base_title;
            location.hash = num + NUMBER_DIFF;

            // youtube用ポップアップ
            $('a.js-youtube').magnificPopup({
                // disableOn: 700,
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
                type: 'iframe',
                iframe: {
                    patterns: {
                        youtube: {
                            index: 'youtube.com',
                            id: 'v=',
                            src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
                        }
                    }
                }
            });

        });
    }

    // 指定話数の画像プリロード
    function preload_gallery(num) {
        var episode = _vm_episode.episode_list[ num ];
        var urls = episode.images.map(function (image) { return image.src });
        var preload = require('../caracol2/util/preload.js');
        // $.Differed オブジェクトを返す
        return preload( urls );
    }

    /**
     * 画像切り替え
     * @param {int} num
     * @param {object} event
     */
    function change_gallery(num, event) {
        _data.now_gallery = num;
    }

}




//////////////////
// WEBPACK FOOTER
// ./js/page/episode.js
// module id = 11
// module chunks = 0